'use strict';

export default class UpcomingPaymentArrangements {
    
   


    constructor() {

        var controllerUrl = "/api/sitecore/UpcomingPaymentArrangement";

        var phoneUpdateUrl="/UpdatePhoneNumber";

        var phoneAddUrl="/AddPhoneNumber";

        var getPhoneNumberUrl="/GetPhoneNumber";

        var phoneDataUrl="";

        var upcomingPaymentDataUrl="/GetUpcomingPayments";

        var phoneNumber = null;

        var phoneStatus = null;

        var isEnabled = false;

        var phoneId = null;


        var queryString = window.location.search;
        
        
        
        
        var debtorId = null;
        $.ajax({  // LOAD THE USER'S DATA IN THE FIRST PLACE
				method: "POST",
                url: window.location.origin + controllerUrl + getPhoneNumberUrl,
				success:function( response ){
                        if(typeof response.ID != "undefined"){
                            phoneNumber = response.Number;
                            isEnabled = response.IsEnabled;
                            phoneId = response.ID;
                            $('#PhoneNumberSMS').val(phoneNumber);

                            syncPhoneState(phoneNumber,isEnabled);
                            
                        }else{
                            $('#notification').html('If you would like to receive an SMS reminder about your payment arrangement, please enter your mobile phone number below.');

                            syncPhoneState(null,isEnabled);
	
                            $('#disable-btn').attr('disabled', true);
                        
                            $('#enable-btn').removeAttr('disabled');
                        
                            $('#delete-btn').attr('disabled', true);
                            $('#delete-btn').addClass('sms-btn-disable');
                        }
                        
					}
				});
        
        $.ajax({  // LOAD THE USER'S UPCOMING PAYMENT DATA IN THE FIRST PLACE
				method: "POST",
                url: window.location.origin + controllerUrl + upcomingPaymentDataUrl,
				success:function( response ){
                        displayUpcomingPayments(response);
                        attachShowUpcomingListeners();
					}
				});

        

        $('.sms-button').click(function(){
            var enabled = $(this).data('enabled');
            var deletePhone = $(this).data('delete');
            var phoneNumberInput = $('#PhoneNumberSMS').val();
            var url = "";
            $('#sms-errors').html('');
            if(phoneNumber == null){
                //add new phone number
                if(!validatePhoneNumber()){
                   
                    return;
                }
                url = window.location.origin + controllerUrl + phoneAddUrl;
                var data = {
                    phoneNumber: phoneNumberInput,
                    enable: enabled == 1?true:false
                }
                $.ajax({  // add the new phone number
                    method: "POST",
                    url: url,
                    data:data,
                    success:function( response ){
                        phoneId = response.ID;
                        $('#notification').html(response.Texts);
                        syncPhoneState(phoneNumberInput,true)
                        
                        }
                    });
            }else{
                //update the existing
                url = window.location.origin + controllerUrl + phoneUpdateUrl;

                if(!deletePhone){
                    if(!validatePhoneNumber()){
                   
                        return;
                    }
                }
                var data = {
                    ID: phoneId,
                    phoneNumber: phoneNumberInput,
                    delete: deletePhone == 1?true:false,
                    enable: enabled == 1?true:false
                }
                $.ajax({  // edit the  phone number
                    method: "POST",
                    url: url,
                    data:data,
                    success:function( response ){
                        $('#notification').html(response.Texts);
                        syncPhoneState( phoneNumberInput, enabled == 1?true:false, deletePhone == 1?true:false)
                        $('#sms-errors').html('');
                    }
                });
            }

        });

        function validatePhoneNumber(){


            //var reg = new RegExp('^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$','g');
            var reg = new RegExp('[0-9]{10}','g');
            
            if($('#PhoneNumberSMS').val() == ''){
                $('#sms-errors').html('Please enter a mobile number');
                return false;
            }
            
            if($('#PhoneNumberSMS').val().length != 10){
                $('#sms-errors').html('The character`s number must be 10');
                return false;
            }

            if(!reg.test($('#PhoneNumberSMS').val())){
                $('#sms-errors').html('Please enter the phone number in the valid format');
                return false;
            }

            
            return true;
        }

        function attachShowUpcomingListeners() {
            $('.ShowAllUpcomingFines').on('click', function()
            {
                var isHidden = String($(this).data('content-hidden'));
                var fineType = $(this).find('.fineType').html();
                var fineCount = parseInt($(this).find('.TotalFines').html());
                var listItems = $(this).parent().prev('.content-holder').find('li');

                if(isHidden == 'true')
                {
                    //get the amount of fines that will be hidden when clicked again
                    fineCount -= 10;

                    //show all items in list
                    listItems.show();

                    $(this).html('Hide <span class="bold TotalFines">'+fineCount+'</span><span class="fineType">'+fineType+'</span>');

                     $(this).data('content-hidden','false');
                }
                else
                {
                    //get the total number of fines in the section
                    fineCount += 10;
                    //hide all elements in the list
                    listItems.hide();
                    //show first 5 items in the list
                    listItems.slice(0,10).show();

                    $(this).html('Show all <span class="bold TotalFines">'+fineCount+'</span><span class="fineType">'+fineType+'</span>');

                    $(this).data('content-hidden','true');

                }
            });
        }

        function displayUpcomingPayments(upcomingPayments) {
          var relevantPayments = [];
          var todaysDate = new Date();
          var upcomingPaymentNoArr = [];
          var upcomingDueDateArr = [];
          var upcomingInstalmentAmtPaymentArr = [];
          var upcomingAmtDuePaymentArr = [];
          var listEntryArr = [];
          var selectedPaymentArrangementNo = "";
          var numPayments = 0;
          var upcomingPaymentNum = '';
          var sortByDate = false;
          var sortByInstalment = false;
          var sortByAmt = false;
          var mobileSortOrder = '';
          var firstPayment = '';
          var initialUpdateDate = '';
          var lastUpdateDateFull = "";
          var payYourFineUrl = window.location.href.substr(0, window.location.href.indexOf('/Your'));
        
          payYourFineUrl = payYourFineUrl + "/api/sitecore/Payment/Pay";
          
          //set 'selectedPaymentArrangementNo' variable to the payment arrangement number selected on the previous page
          if (localStorage.getItem('selectedPaymentArrangementNo') !== null && upcomingPayments.length !== 0) {
            selectedPaymentArrangementNo = localStorage.getItem('selectedPaymentArrangementNo');
          }
      
          $('#UpcomingPaymentArrangement').html('');
          $('.header-container .wrapper').html('<div class="arrangement-bread-crumb">HOME /  <span class="bread-crumb-payment-no"> PAYMENT ARRANGEMENT ' + selectedPaymentArrangementNo + '</span></div> <div> <h3>Payment Arrangement ' + selectedPaymentArrangementNo + '</h3></div>');
          $('#upcomingPaymentArrangementTableHeader').append('<div> <h4>Upcoming payments on payment arrangement ' + selectedPaymentArrangementNo + '</h4></div>');
      
          //populate 'relevantPayments' array with payments in 'upcomingPayments' with the same arrangement number as the one selected
          for (var i = 0; i < upcomingPayments.length; i++) {
            const fine = upcomingPayments[i];
            if (fine.ArrangementNo == selectedPaymentArrangementNo){
            relevantPayments.push(fine);
            }
          }
      
          initialUpdateDate = relevantPayments[0].LastUpdatedString.substr(0, 10);
      
          //if upcomingPayments is empty OR upcomingPayments does not contain any payments related to the selected payment arrangement number
          if (upcomingPayments.length == 0 || relevantPayments == []) {
            $('.header-container .wrapper').html('<div class="arrangement-bread-crumb">HOME /  <span class="bread-crumb-payment-no"> PAYMENT ARRANGEMENT ' + selectedPaymentArrangementNo + '</span></div> <div> <h3>Payment Arrangement ' + selectedPaymentArrangementNo + '</h3></div>');
            $('#upcomingPaymentArrangementTableHeader').append('<div> <h4>Upcoming payments on payment arrangement ' + selectedPaymentArrangementNo + '</h4></div>');
            $('#UpcomingPaymentArrangement').css("display", "none");
            return;
          }
          
          for (var upcomingPaymentNum = 0; upcomingPaymentNum < relevantPayments.length; upcomingPaymentNum++) {
            
            var fine = relevantPayments[upcomingPaymentNum];
      
            //initialise UpcomingPaymentDetailsArr to store ids, instalment amounts, due amounts and due dates for relevant upcoming payments
            var UpcomingPaymentDetailsArr = {};
            UpcomingPaymentDetailsArr['id'] = upcomingPaymentNum;
            UpcomingPaymentDetailsArr['instalmentAmt'] = fine.InstalmentAmt;
            UpcomingPaymentDetailsArr['amtDue'] = fine.Amtdue;
            UpcomingPaymentDetailsArr['dueDate'] = fine.DuedateString;
        
            var lastUpdateDate = "";
            var amtDueString = fine.Amtdue + "";
            var instalmentAmtString = fine.InstalmentAmt + "";
        
            //format due amounts to capture dollar and cent amounts 
            if (amtDueString.includes('.')) {
              var amtDueCentIndex = amtDueString.slice(amtDueString.lastIndexOf('.') + 1);
            if (amtDueCentIndex.length == 1) {
            amtDueString = amtDueString + "0";
            }
            } 
            else {
            amtDueString = amtDueString + ".00";
      
            //format instalment amounts to capture dollar and cent amounts 
            }
            if (instalmentAmtString.includes('.')) {
            var instalmentAmtCentIndex = instalmentAmtString.slice(instalmentAmtString.lastIndexOf('.') + 1);
            if (instalmentAmtCentIndex.length == 1) {
            instalmentAmtString = instalmentAmtString + "0";
            }
            } 
            else {
            instalmentAmtString = instalmentAmtString + ".00";
            }
        
            var isHidden = "";
            var newUpdateDate = fine.LastUpdatedString;
            var overdueStatus = checkOverdueStatus(todaysDate, fine.DuedateString);
            var lastUpdateDateData = getLastRefreshDate(initialUpdateDate, newUpdateDate);
            var dueDate = fine.DuedateString;
            var htmlToInsert = '<li id="upcomingPaymentEntry_' + upcomingPaymentNum + '"style="' + isHidden + '">' + '<a href="javascript:void(0)" class="head head-date-data no-print">' + '<span class="no-print">' + dueDate + '<span class="icon-accordion-toggle no-print" href="javascript:void(0)" title="Expand and close"><span class="sr-only no-print"> Open / Close </span></span>' + '</a>' + '<div class="body upcoming-payment-body no-border"><table>' + '<tbody>' + '<tr>' + '<td class="due-date-mobile due-date-desktop margin-five"><span class="flex-display"><label class="subsequent-upcoming-payment-label no-print">DUE DATE</label><span id= "upcomingPaymentDateStatus_' + upcomingPaymentNum + '" class="dueSoon overdue-label date-status-print no-display">Overdue</span><span id="upcomingPaymentDateField_' + upcomingPaymentNum + '"class="vic-font left-align date-field-print">' + dueDate + '</span></td></span>' + '<td class="due-date-mobile instalment-amt-desktop"><span class="flex-display"><label class="subsequent-upcoming-payment-label">INSTALMENT AMOUNT</label><span class="vic-font left-align instalment-amt-print">$' + instalmentAmtString + '</span></span></td>' + '<td class = "due-date-mobile"><span class="flex-display"><label class="subsequent-upcoming-payment-label">AMOUNT DUE</label><span class="vic-font left-align">$' + amtDueString + '</span></span></td>' + '<td class="fines-table-td-overdue-notif due-soon-td">' + '</td> </tr>' + '</tbody>' + '</table>' + '</div>' + '</li>';
        
            $('#UpcomingPaymentArrangement').append(htmlToInsert);
      
            //add styling for the first upcoming payment
            if (upcomingPaymentNum == 0) {
            firstPayment = '#upcomingPaymentEntry_' + upcomingPaymentNum;
            $(firstPayment).addClass('first-upcoming-payment-entry');
            $(firstPayment).append('<div class="upcoming-pay-div"><form action="' + payYourFineUrl + '" method="post" style="display:inline">\n\t\t\t\t\t\t\t\t\t\t\t\t<input type="hidden" name="Identifier" value="' + relevantPayments[0].ArrangementNo + '">\n\t\t\t\t\t\t\t\t\t\t\t\t<input type="hidden" name="currentPage" value="' + window.location.href + '">\n\t\t\t\t\t\t\t\t\t\t\t\t<button type="submit" class="btn btn-colored white upcoming-arr-pay">Pay</button>\n\t\t\t\t\t\t\t\t\t\t\t</form></div>');
            }
      
            //hide every payment after the first 10
            if (upcomingPaymentNum > 9) {
            $('#upcomingPaymentEntry_' + upcomingPaymentNum).css("display", "none");
            }
      
            //if there are more than 10 upcoming payments, display the 'show all pamyents' option at the bottom of the page and populate the text with total number of payments
            if (relevantPayments.length > 10) {
            $('#ShowAllUpcoming').show();
            $('#ShowAllUpcoming .TotalFines').html(relevantPayments.length);
            }
      
            //if payment is overdue, add styling for overdue payments
            if (overdueStatus == true) {
            $('#upcomingPaymentDateStatus_' + upcomingPaymentNum).removeClass("no-display");
            $('#upcomingPaymentDateField_' + upcomingPaymentNum).addClass("no-display no-print");
            }
      
            listEntryArr.push(htmlToInsert);
            UpcomingPaymentDetailsArr["listEntry"] = htmlToInsert;
      
            upcomingDueDateArr.push(UpcomingPaymentDetailsArr);
            upcomingInstalmentAmtPaymentArr.push(UpcomingPaymentDetailsArr);
            upcomingAmtDuePaymentArr.push(UpcomingPaymentDetailsArr);
      
          }
        
          var firstAmtDueString = relevantPayments[0].Amtdue + "";
        
          var firstInstalmentAmtString = relevantPayments[0].InstalmentAmt + "";
        
          if (firstAmtDueString.includes('.')) {
            var amtDueCentIndex = firstAmtDueString.slice(firstAmtDueString.lastIndexOf('.') + 1);
            if (amtDueCentIndex.length == 1) {
            firstAmtDueString = firstAmtDueString + "0";
            }
          } else {
            firstAmtDueString = firstAmtDueString + ".00";
          }
        
          if (firstInstalmentAmtString.includes('.')) {
            var instalmentAmtCentIndex = firstInstalmentAmtString.slice(firstInstalmentAmtString.lastIndexOf('.') + 1);
            if (instalmentAmtCentIndex.length == 1) {
            firstInstalmentAmtString = firstInstalmentAmtString + "0";
            }
          } else {
            firstInstalmentAmtString = firstInstalmentAmtString + ".00";
          }
        
          if (upcomingPaymentNoArr.length > 1) {
            $('#upcomingPaymentArrangementMultiplePaymentsHeader').css("display", "block");
          } else {
            $('#upcomingPaymentArrangementMultiplePaymentsHeader').css("display", "none");
          }
        
          lastUpdateDate = lastUpdateDateData[0];
          lastUpdateDateFull = lastUpdateDateData[1];
        
          $('#upcomingPaymentArrangementTableHeader').append('<div class="margin-left-auto"><div class="update-information-content"><b>Information last updated: <span id="lastUpdateDateFull">' + lastUpdateDateFull + '</b></div><div>Payments may take up to 24hrs to display here.</div></div>');
        
          var upcomingDueDateArrAsc = upcomingDueDateArr;
          var upcomingDueDateArrDesc = upcomingDueDateArr.slice().reverse();
        
          var upcomingInstalmentAmtPaymentArrAsc = upcomingInstalmentAmtPaymentArr.slice().sort(function (a, b) {
            return a.instalmentAmt > b.instalmentAmt ? 1 : -1;
          });
          var upcomingInstalmentAmtPaymentArrDesc = upcomingInstalmentAmtPaymentArr.slice().sort(function (a, b) {
            return a.instalmentAmt < b.instalmentAmt ? 1 : -1;
          });
        
          var upcomingAmtDuePaymentArrAsc = upcomingAmtDuePaymentArr.slice().sort(function (a, b) {
            return a.amtDue > b.amtDue ? 1 : -1;
          });
          var upcomingAmtDuePaymentArrDesc = upcomingAmtDuePaymentArr.slice().sort(function (a, b) {
            return a.amtDue < b.amtDue ? 1 : -1;
          });
        
          $('#overdue-column').click(function () {
            var count = 0;
            $('#UpcomingPaymentArrangement').html('');
        
            if (sortByDate == false) {
            upcomingDueDateArrDesc.forEach(function (element) {
              var i = element.id;
              $('#UpcomingPaymentArrangement').append(element.listEntry);
              var overdueStatus = checkOverdueStatus(todaysDate, element.dueDate);
              if (overdueStatus == true) {
        
              $('#upcomingPaymentDateStatus_' + i).removeClass("no-display");
              $('#upcomingPaymentDateField_' + i).addClass("no-display no-print");
              }
              if (count > 9) {
              $('#upcomingPaymentEntry_' + element.id).css("display", "none");
              }
            });
            sortByDate = true;
            $('#dueDateSortIcon').removeClass('icon-sort-no-arrow');
            $('#dueDateSortIcon').addClass('icon-sort-arrow');
            $('#dueDateSortIcon').removeClass('icon-sort-arrow-flip');
            } else {
            upcomingDueDateArrAsc.forEach(function (element) {
              var i = element.id;
              $('#UpcomingPaymentArrangement').append(element.listEntry);
              var overdueStatus = checkOverdueStatus(todaysDate, element.dueDate);
              if (overdueStatus == true) {
        
              $('#upcomingPaymentDateStatus_' + i).removeClass("no-display");
              $('#upcomingPaymentDateField_' + i).addClass("no-display no-print");
              }
              if (count > 9) {
              $('#upcomingPaymentEntry_' + element.id).css("display", "none");
              }
            });
            sortByDate = false;
            $('#dueDateSortIcon').addClass('icon-sort-arrow-flip');
            $('#dueDateSortIcon').removeClass('icon-sort-no-arrow');
            }
        
            count++;
        
            $(firstPayment).addClass('first-upcoming-payment-entry');
            $(firstPayment).append('<div class="upcoming-pay-div"><form action="' + payYourFineUrl + '" method="post" style="display:inline">\n\t\t\t\t\t\t\t\t\t\t\t\t<input type="hidden" name="Identifier" value="' + relevantPayments[0].ArrangementNo + '">\n\t\t\t\t\t\t\t\t\t\t\t\t<input type="hidden" name="currentPage" value="' + window.location.href + '">\n\t\t\t\t\t\t\t\t\t\t\t\t<button type="submit" class="btn btn-colored white upcoming-arr-pay">Pay</button>\n\t\t\t\t\t\t\t\t\t\t\t</form></div>');
            $('#instalmentAmtSortIcon').removeClass();
            $('#amtDueSortIcon').removeClass();
            $('#instalmentAmtSortIcon').addClass("icon-sort-no-arrow icon-sort-padding");
            $('#amtDueSortIcon').addClass("icon-sort-no-arrow icon-sort-padding");
            $('#sortOrderMobileText').html('Ordered by Due Date');
          });
        
          $('#instalment-amt-column').click(function () {
            var count = 0;
            if (sortByInstalment == false) {
            $('#UpcomingPaymentArrangement').html('');
            upcomingInstalmentAmtPaymentArrDesc.forEach(function (element) {
              var i = element.id;
              $('#UpcomingPaymentArrangement').append(element.listEntry);
              var overdueStatus = checkOverdueStatus(todaysDate, element.dueDate);
              if (overdueStatus == true) {
        
              $('#upcomingPaymentDateStatus_' + i).removeClass("no-display");
              $('#upcomingPaymentDateField_' + i).addClass("no-display no-print");
              }if (count > 9) {
              $('#upcomingPaymentEntry_' + element.id).css("display", "none");
              }
              count++;
            });
            sortByInstalment = true;
            $('#instalmentAmtSortIcon').removeClass('icon-sort-no-arrow');
            $('#instalmentAmtSortIcon').addClass('icon-sort-arrow');
            $('#instalmentAmtSortIcon').removeClass('icon-sort-arrow-flip');
            } else {
            $('#UpcomingPaymentArrangement').html('');
            upcomingInstalmentAmtPaymentArrAsc.forEach(function (element) {
              var i = element.id;
              $('#UpcomingPaymentArrangement').append(element.listEntry);
              var overdueStatus = checkOverdueStatus(todaysDate, element.dueDate);
              if (overdueStatus == true) {
        
              $('#upcomingPaymentDateStatus_' + i).removeClass("no-display");
              $('#upcomingPaymentDateField_' + i).addClass("no-display no-print");
              }if (count > 9) {
              $('#upcomingPaymentEntry_' + element.id).css("display", "none");
              }
              count++;
            });
            sortByInstalment = false;
            $('#instalmentAmtSortIcon').addClass('icon-sort-arrow-flip');
            $('#instalmentAmtSortIcon').removeClass('icon-sort-no-arrow');
            }
            $(firstPayment).addClass('first-upcoming-payment-entry');
            $(firstPayment).append('<div class="upcoming-pay-div"><form action="' + payYourFineUrl + '" method="post" style="display:inline">\n\t\t\t\t\t\t\t\t\t\t\t\t<input type="hidden" name="Identifier" value="' + relevantPayments[0].ArrangementNo + '">\n\t\t\t\t\t\t\t\t\t\t\t\t<input type="hidden" name="currentPage" value="' + window.location.href + '">\n\t\t\t\t\t\t\t\t\t\t\t\t<button type="submit" class="btn btn-colored white upcoming-arr-pay">Pay</button>\n\t\t\t\t\t\t\t\t\t\t\t</form></div>');
            $('#dueDateSortIcon').removeClass();
            $('#amtDueSortIcon').removeClass();
            $('#dueDateSortIcon').addClass("icon-sort-no-arrow icon-sort-padding");
            $('#amtDueSortIcon').addClass("icon-sort-no-arrow icon-sort-padding");
            $('#sortOrderMobileText').html('Ordered by Instalment Amount');
          });
        
          $('#amt-due-column').click(function () {
            var count = 0;
            if (sortByAmt == false) {
            $('#UpcomingPaymentArrangement').html('');
            upcomingAmtDuePaymentArrDesc.forEach(function (element) {
              var i = element.id;
              $('#UpcomingPaymentArrangement').append(element.listEntry);
              var overdueStatus = checkOverdueStatus(todaysDate, element.dueDate);
              if (overdueStatus == true) {
        
              $('#upcomingPaymentDateStatus_' + i).removeClass("no-display");
              $('#upcomingPaymentDateField_' + i).addClass("no-display no-print");
              }if (count > 9) {
              $('#upcomingPaymentEntry_' + element.id).css("display", "none");
              }
              count++;
            });
            sortByAmt = true;
            $('#amtDueSortIcon').removeClass('icon-sort-no-arrow');
            $('#amtDueSortIcon').addClass('icon-sort-arrow');
            $('#amtDueSortIcon').removeClass('icon-sort-arrow-flip');
            } else {
            $('#UpcomingPaymentArrangement').html('');
            upcomingAmtDuePaymentArrAsc.forEach(function (element) {
              var i = element.id;
              $('#UpcomingPaymentArrangement').append(element.listEntry);
              var overdueStatus = checkOverdueStatus(todaysDate, element.dueDate);
              if (overdueStatus == true) {
        
              $('#upcomingPaymentDateStatus_' + i).removeClass("no-display");
              $('#upcomingPaymentDateField_' + i).addClass("no-display no-print");
              }if (count > 9) {
              $('#upcomingPaymentEntry_' + element.id).css("display", "none");
              }
              count++;
            });
            sortByAmt = false;
            $('#amtDueSortIcon').addClass('icon-sort-arrow-flip');
            $('#amtDueSortIcon').removeClass('icon-sort-no-arrow');
            }
            $(firstPayment).addClass('first-upcoming-payment-entry');
            $(firstPayment).append('<div class="upcoming-pay-div"><form action="' + payYourFineUrl + '" method="post" style="display:inline">\n\t\t\t\t\t\t\t\t\t\t\t\t<input type="hidden" name="Identifier" value="' + relevantPayments[0].ArrangementNo + '">\n\t\t\t\t\t\t\t\t\t\t\t\t<input type="hidden" name="currentPage" value="' + window.location.href + '">\n\t\t\t\t\t\t\t\t\t\t\t\t<button type="submit" class="btn btn-colored white upcoming-arr-pay">Pay</button>\n\t\t\t\t\t\t\t\t\t\t\t</form></div>');
            $('#dueDateSortIcon').removeClass();
            $('#instalmentAmtSortIcon').removeClass();
            $('#dueDateSortIcon').addClass("icon-sort-no-arrow icon-sort-padding");
            $('#instalmentAmtSortIcon').addClass("icon-sort-no-arrow icon-sort-padding");
          });
        
          $("#sort-upcoming-desc-mobile").click(function () {
            sortByDate = false;
            sortByInstalment = false;
            sortByAmt = false;
            mobileSortOrder = "desc";
            $('#sortOrderMobileText').html('Unordered');
            $('#mobileSortIcon').addClass("icon-sort-no-arrow");
          });
        
          $("#sort-upcoming-asc-mobile").click(function () {
            sortByDate = true;
            sortByInstalment = true;
            sortByAmt = true;
            mobileSortOrder = "asc";
            $('#sortOrderMobileText').html('Unordered');
            $('#mobileSortIcon').addClass("icon-sort-no-arrow");
          });
        
          $('#mobile-sort-due-date').click(function () {
            if (mobileSortOrder == "desc") {
            $('#overdue-column').click();
            mobileSortOrder = "";
            $('#mobileSortIcon').addClass("icon-sort-padding icon-sort-arrow");
            $('#mobileSortIcon').removeClass("icon-sort-no-arrow icon-sort-arrow-flip");
            } else if (mobileSortOrder == "asc") {
            $('#overdue-column').click();
            mobileSortOrder = "";
            $('#mobileSortIcon').addClass("icon-sort-padding icon-sort-arrow icon-sort-arrow-flip");
            $('#mobileSortIcon').removeClass("icon-sort-no-arrow");
            }
            $('#sortOrderMobileText').html('Ordered by Due Date');
          });
        
          $('#mobile-sort-instalment-btn').click(function () {
            if (mobileSortOrder == "desc") {
            $('#instalment-amt-column').click();
            mobileSortOrder = "";
            $('#mobileSortIcon').addClass("icon-sort-padding icon-sort-arrow");
            $('#mobileSortIcon').removeClass("icon-sort-no-arrow icon-sort-arrow-flip");
            } else if (mobileSortOrder == "asc") {
            $('#instalment-amt-column').click();
            mobileSortOrder = "";
            $('#mobileSortIcon').addClass("icon-sort-padding icon-sort-arrow icon-sort-arrow-flip");
            $('#mobileSortIcon').removeClass("icon-sort-no-arrow");
            }
            $('#sortOrderMobileText').html('Ordered by Instalment Amount');
          });
        
          $('#mobile-sort-amt-due').click(function () {
            if (mobileSortOrder == "desc") {
            $('#amt-due-column').click();
            mobileSortOrder = "";
            $('#mobileSortIcon').addClass("icon-sort-padding icon-sort-arrow");
            $('#mobileSortIcon').removeClass("icon-sort-no-arrow icon-sort-arrow-flip");
            } else if (mobileSortOrder == "asc") {
            $('#amt-due-column').click();
            mobileSortOrder = "";
            $('#mobileSortIcon').addClass("icon-sort-padding icon-sort-arrow icon-sort-arrow-flip");
            $('#mobileSortIcon').removeClass("icon-sort-no-arrow");
            }
            $('#sortOrderMobileText').html('Ordered by Amount Due');
          });
        
          $('#change-upcoming-order').click(function () {
            var displayed = '';
            if ($('#upcoming-sort-slide').css('display') == 'none') {
            $('#upcoming-sort-slide').slideToggle();
            } else {
            $('#upcoming-sort-slide').slideToggle();
            }
          });
        
          $('#sort-upcoming-asc-mobile').click(function () {
            mobileSortOrder = "asc";
            $('#sort-upcoming-asc-mobile').addClass("fines-list-sort-order-btn active");
            $('#sort-upcoming-desc-mobile').removeClass("active");
          });
          $('#sort-upcoming-desc-mobile').click(function () {
            mobileSortOrder = "desc";
            $('#sort-upcoming-desc-mobile').addClass("fines-list-sort-order-btn active");
            $('#sort-upcoming-asc-mobile').removeClass("active");
          });
        }
      
        var checkOverdueStatus = function checkOverdueStatus(todaysDate, paymentDate) {
      
          var parseDate = function parseDate(s) {
            var b = s.split(/\D/);
            return Date.UTC(b[2], --b[1], b[0]);
          };
        
          todaysDate = parseDate(todaysDate.getDate() + '/' + (todaysDate.getMonth() + 1) + '/' + todaysDate.getFullYear());
          paymentDate = parseDate(paymentDate.substr(0, 10));
        
          var overdueStatus = todaysDate > paymentDate;
        
          return overdueStatus;
        };
      
          var getLastRefreshDate = function getLastRefreshDate(initialUpdateDate, newUpdateDate) {
        
          function parseDate(s) {
            var b = s.split(/\D/);
            return Date.UTC(b[2], --b[1], b[0]);
          };
        
          var lastUpdateDate = initialUpdateDate;
        
          var lastUpdateDateFull = "";
        
          var initialUpdateDateParsed = parseDate(initialUpdateDate.substr(0, 10));
        
          var newUpdateDateParsed = parseDate(newUpdateDate.substr(0, 10));
        
          if (initialUpdateDateParsed < newUpdateDateParsed) {
            lastUpdateDate = newUpdateDate;
          }
        
          var lastUpdateDay = lastUpdateDate.substr(0, 2);
          var lastUpdateMonth = lastUpdateDate.substr(3, 2);
          var lastUpdateYear = lastUpdateDate.substr(6, 4);
        
          switch (lastUpdateMonth) {
            case "01":
            lastUpdateMonth = "Jan";
            break;
            case "02":
            lastUpdateMonth = "Feb";
            break;
            case "03":
            lastUpdateMonth = "Mar";
            break;
            case "04":
            lastUpdateMonth = "Apr";
            break;
            case "05":
            lastUpdateMonth = "May";
            break;
            case "06":
            lastUpdateMonth = "Jun";
            break;
            case "07":
            lastUpdateMonth = "Jul";
            break;
            case "08":
            lastUpdateMonth = "Aug";
            break;
            case "09":
            lastUpdateMonth = "Sep";
            break;
            case "10":
            lastUpdateMonth = "Oct";
            break;
            case "11":
            lastUpdateMonth = "Nov";
            break;
            case "12":
            lastUpdateMonth = "Dec";
            break;
          }
          lastUpdateDateFull = lastUpdateDay + " " + lastUpdateMonth + " " + lastUpdateYear;
        
          return [lastUpdateDate, lastUpdateDateFull];
        };
    
      function syncPhoneState(phoneNumberParams, enabledParams) {
      var deleteParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    
      phoneNumber = phoneNumberParams;
      isEnabled = enabledParams;
    
      if (deleteParams) {
        phoneId = null;
        phoneNumber = null;
        isEnabled = false;
        $('#PhoneNumberSMS').val('');
    
        $('#disable-btn').attr('disabled', true);
        $('#disable-btn').addClass('sms-btn-disable');
    
        $('#enable-btn').removeAttr('disabled');
        $('#enable-btn').removeClass('sms-btn-disable');
    
        $('#delete-btn').attr('disabled', true);
        $('#delete-btn').addClass('sms-btn-disable');
      } else if (enabledParams) {
    
        $('#disable-btn').removeAttr('disabled');
        $('#disable-btn').removeClass('sms-btn-disable');
    
        $('#enable-btn').attr('disabled', true);
        $('#enable-btn').addClass('sms-btn-disable');
    
        $('#delete-btn').removeAttr('disabled');
        $('#delete-btn').removeClass('sms-btn-disable');
      } else if (!enabledParams) {
    
        $('#disable-btn').attr('disabled', true);
        $('#disable-btn').addClass('sms-btn-disable');
    
        $('#enable-btn').removeAttr('disabled');
        $('#enable-btn').removeClass('sms-btn-disable');
    
        $('#delete-btn').removeAttr('disabled');
        $('#delete-btn').removeClass('sms-btn-disable');
      }
      }
    
};
}